import { UserDefault } from '@src/lib';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

interface WithHistoryProps {
  props: any;
  WrappedComponent: React.ComponentType<any>;
}

const WithHistory = (props: WithHistoryProps) => {
  const { WrappedComponent } = props;
  const router = useRouter();

  useEffect(() => {
    UserDefault.PageHistory.setter(router.asPath);
  }, [router]);

  return (
    <>
      <WrappedComponent {...props.props} />
    </>
  );
};

export default WithHistory;
